import type { ChangeEvent, ReactNode, RefObject } from "react";
// import { AttachmentSection } from "../../../components/Form/AttachmentSection";
import type { LegalAdviceFormTwoData } from "../../../types/LegalAdvices/LegalAdviceFormTwo.type";
import { DatalistInput } from "../components/dataListInput";
// import { FormActionButtons } from "../../../components/Form/FormActionButton";
import { useSettings } from "../../../context/SettingContext";


export interface AttachmentFile {
  name: string;
  [key: string]: any;
}

export interface DetailFormDocumentProps {
  formData: LegalAdviceFormTwoData;
  isEditable: boolean;
  isSigning: boolean;
  sigCanvasRef: RefObject<any>;
  setIsSigning: (isSigning: boolean) => void;
  handleChange: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  handleSaveSignature: () => void;
  renderDocumentRow: (label: string, fieldName: any) => ReactNode;
  renderDatePicker: (fieldName: any) => ReactNode;

  // Additional props required for action controls inside this component
  isPreview?: boolean;
  // isSubmitting?: boolean;
  // isApproved?: boolean;
  handleBackNavigation: () => void;
  // handleSaveDraft: (e: React.MouseEvent) => void;
  // handleSubmitToSuperior: (e: React.MouseEvent) => void;
 // handleAttachment:(e:React.MouseEvent)=> void;
}

export const LegalDetailFormTwoDocument: React.FC<DetailFormDocumentProps> = ({
  formData,
  isEditable,
  // isSigning,
  // sigCanvasRef,
  setIsSigning,
  handleChange,
  // handleSaveSignature,
  renderDatePicker,
  // isApproved,
  isPreview = false,
  // isSubmitting = false,
  // handleBackNavigation,
  // handleSaveDraft,
  // handleSubmitToSuperior,
  // handleAttachment
}) => {
  // Replace these with your actual option data sources or imports
 const { settings } = useSettings();

//  const isFormSigned = Boolean(
//     formData.signatureImage?.trim() && 
//     (formData.signerName?.trim() || formData.signName?.trim())
//   );

// Map to simple string arrays for your dropdowns/datalists
const OFFICE_OPTIONS = settings?.offices.map((o) => o.name) || [];
const TOWNSHIP_OPTIONS = settings?.townships.map((t) => t.name) || [];
const DISTRICT_OPTIONS = settings?.townships.map((t) => t.name) || [];
const STATE_OPTIONS = settings?.townships.map((t) => t.name) || [];


  return (
    /* A4 Sheet Container */
        <div className="w-full max-w-[800px] bg-white shadow-lg border border-gray-300 p-16 text-black leading-loose relative text-sm md:text-base print:shadow-none print:border-none print:p-0 print:max-w-full">
            
            {/* Right Top Form Label Tag */}
            <div className="absolute top-6 right-8 text-sm font-bold text-right space-y-0.5 print:top-0 print:right-0">
              <div>ဥပရအမှုလိုက်ပုံစံ ( ၂ )</div>
            </div>
    
            {/* Central National Document Headers */}
            <div className="text-center space-y-1 mt-8">
              <h1 className="text-lg font-bold">ပြည်ထောင်စုသမ္မတမြန်မာနိုင်ငံတော်အစိုးရ</h1>
              <h2 className="text-md font-bold">ပြည်ထောင်စုရှေ့နေချုပ်ရုံး</h2>
              {/* <div className="text-sm font-bold">မှ</div> */}
              <div className="flex justify-center items-center gap-2">
                <DatalistInput
                  name="office"
                  value={formData.office || ""}
                  onChange={handleChange}
                  placeholder=""
                  options={OFFICE_OPTIONS}
                  disabled={!isEditable}
                />
                <span className="w-24 text-left">ရုံး</span>
              </div>
            </div>
    
            {/* Reference Case Identity Line decoration */}
            <div className="mt-6 flex flex-col items-center space-y-4">
              <div className="flex items-center justify-center text-center w-full max-w-xl leading-8 flex-wrap">
                {isPreview ? (
                  <span className="min-w-[5rem] border-b border-black text-center font-semibold px-2">{formData.caseYear || '....'}</span>
                ) : (
                  <input 
                    type="text" 
                    name="caseYear"
                    value={formData.caseYear}
                    onChange={handleChange}
                    className="w-20 text-center bg-transparent border-b border-dotted border-black focus:outline-none"
                  />
                )}
                <span className="mx-1">ခုနှစ်၊ အစိုးရသက်သေပြုလုပ်ခြင်း၊ အမှုတွဲအမှတ် (</span>
                {isPreview ? (
                  <span className="min-w-[5rem] border-b border-black text-center font-semibold px-2">{formData.caseNo || '....'}</span>
                ) : (
                  <input 
                    type="text" 
                    name="caseNo"
                    value={formData.caseNo}
                    onChange={handleChange}
                    className="w-20 text-center bg-transparent border-b border-dotted border-black focus:outline-none"
                  />
                )}
                <span className="mx-1">)</span>
              </div>
    
              {/* Unified Form Calendar Picker */}
              <div className="flex items-center gap-2 w-64 justify-end">
                <span className="whitespace-nowrap">ရက်စွဲ၊</span>
                <div className="flex-grow">{renderDatePicker('date')}</div>
              </div>
            </div>
    
            {/* Centered Document Title */}
            <div className="text-center mt-10 mb-8">
              <h2 className="text-base font-bold tracking-wide underline underline-offset-8 decoration-1">
                တရားခံအား စည်းကမ်းချက်ဖြင့် ပြစ်ဒဏ်မှ လွတ်ငြိမ်းခွင့် ပေးသည့်အမိန့်
              </h2>
            </div>
    
            {/* Main Form Body structures */}
            <div className="space-y-8 text-justify leading-9">
              
              {/* Paragraph 1 */}
              <div className="relative pl-8">
                <span className="absolute left-0 top-0 font-bold">၁။</span>
                <div className="leading-9">
                  <DatalistInput
                    name="state"
                    value={formData.state || ""}
                    onChange={handleChange}
                    placeholder=""
                    options={STATE_OPTIONS}
                    disabled={!isEditable}
                    className="inline-block w-32 align-baseline bg-transparent border-b border-dotted border-black text-center focus:outline-none"
                  />
                  <span> ပြည်နယ်/တိုင်းဒေသကြီး၊ </span>
                  <DatalistInput
                    name="district"
                    value={formData.district || ""}
                    onChange={handleChange}
                    placeholder=""
                    options={DISTRICT_OPTIONS}
                    disabled={!isEditable}
                    className="inline-block w-24 align-baseline bg-transparent border-b border-dotted border-black text-center focus:outline-none"
                  />
                  <span> ခရိုင် </span>
                  <DatalistInput
                    name="township"
                    value={formData.township || ""}
                    onChange={handleChange}
                    placeholder=""
                    options={TOWNSHIP_OPTIONS}
                    disabled={!isEditable}
                    className="inline-block w-32 align-baseline bg-transparent border-b border-dotted border-black text-center focus:outline-none"
                  />
                  <span> မြို့နယ် ရဲတပ်ဖွဲ့မှူးက အစီရင်ခံစာတင်သွင်းသည်။ </span>
                  {isPreview ? (
                    <span className="inline-block min-w-12 border-b border-black px-1 text-center font-semibold">{formData.complaintNo}</span>
                  ) : (
                    <input type="text" name="complaintNo" value={formData.complaintNo} onChange={handleChange} className="inline-block w-12 align-baseline bg-transparent border-b border-dotted border-black text-center focus:outline-none" />
                  )}
                  <span> ရဲစခန်း၊ ပထမသတင်းပေး တိုင်တန်းချက်အမှတ် (ပ) </span>
                  {isPreview ? (
                    <span className="inline-block min-w-12 border-b border-black px-1 text-center font-semibold">{formData.refNo}</span>
                  ) : (
                    <input type="text" name="refNo" value={formData.refNo} onChange={handleChange} className="inline-block w-12 align-baseline bg-transparent border-b border-dotted border-black text-center focus:outline-none" />
                  )}
                  <span> ဥပဒေပုဒ်မ </span>
                  {isPreview ? (
                    <span className="inline-block min-w-20 border-b border-black px-1 text-center font-semibold">{formData.lawSection}</span>
                  ) : (
                    <input type="text" name="lawSection" value={formData.lawSection} onChange={handleChange} className="inline-block w-20 align-baseline bg-transparent border-b border-dotted border-black text-center focus:outline-none" />
                  )}
                  <span> အရ အရေးယူခံရသူ </span>
                  {isPreview ? (
                    <span className="inline-block min-w-24 border-b border-black px-1 text-center font-semibold">{formData.accusedName}</span>
                  ) : (
                    <input type="text" name="accusedName" value={formData.accusedName} onChange={handleChange} className="inline-block w-24 align-baseline bg-transparent border-b border-dotted border-black text-center focus:outline-none" />
                  )}
                  <span> အား ရာဇဝတ်ကျင့်ထုံးဥပဒေပုဒ်မ ၃၃၇ အရ စည်းကမ်းချက်ဖြင့် ပြစ်ဒဏ်မှ လွတ်ငြိမ်းခွင့်ပေးရန် </span>
                  <DatalistInput
                    name="officerState"
                    value={formData.officerState || ""}
                    onChange={handleChange}
                    placeholder=""
                    options={STATE_OPTIONS}
                    disabled={!isEditable}
                    className="inline-block w-32 align-baseline bg-transparent border-b border-dotted border-black text-center focus:outline-none"
                  />
                  <span> ပြည်နယ်/တိုင်းဒေသကြီး၊ </span>
                  <DatalistInput
                    name="officerDistrict"
                    value={formData.officerDistrict || ""}
                    onChange={handleChange}
                    placeholder=""
                    options={DISTRICT_OPTIONS}
                    disabled={!isEditable}
                    className="inline-block w-24 align-baseline bg-transparent border-b border-dotted border-black text-center focus:outline-none"
                  />
                  <span> ခရိုင်၊ </span>
                  <DatalistInput
                    name="officerTownship"
                    value={formData.officerTownship || ""}
                    onChange={handleChange}
                    placeholder=""
                    options={TOWNSHIP_OPTIONS}
                    disabled={!isEditable}
                    className="inline-block w-32 align-baseline bg-transparent border-b border-dotted border-black text-center focus:outline-none"
                  />
                  <span> မြို့နယ်ရဲတပ်ဖွဲ့မှူးက အစီရင်ခံစာတင်သွင်းသည်။</span>
                </div>
              </div>
    
              {/* Paragraph 2 */}
              <div className="relative pl-8">
                <span className="absolute left-0 top-0 font-bold">၂။</span>
                <div className="inline">
                  <span>အဆိုပါအမှုနှင့်စပ်လျဉ်း၍</span>
                  
                  {isPreview ? (
                    <span className="border-b border-black font-semibold px-4 mx-1 min-w-[8rem] inline-block text-center">{formData.courtName || '.......'}</span>
                  ) : (
                    <input 
                      type="text" 
                      name="courtName"
                      value={formData.courtName}
                      onChange={handleChange}
                      placeholder="တရားရုံး"
                      className="w-40 text-center bg-transparent border-b border-dotted border-black focus:outline-none mx-1"
                    />
                  )}
    
                  <span>တရားရုံး၊ ပြစ်မှုဆိုင်ရာ အထွေထွေမှုအမှတ်</span>
                  
                  {isPreview ? (
                    <span className="border-b border-black font-semibold px-4 mx-1 min-w-[8rem] inline-block text-center">{formData.miscCaseNo || '.......'}</span>
                  ) : (
                    <input 
                      type="text" 
                      name="miscCaseNo"
                      value={formData.miscCaseNo}
                      onChange={handleChange}
                      className="w-40 text-center bg-transparent border-b border-dotted border-black focus:outline-none mx-1"
                    />
                  )}
    
                  <span>တွင် တရားခံက ပေးထားသော ဖြောင့်ချက် သို့မဟုတ် ဥပဒေရုံးတွင် တရားခံထွက်ဆိုထားသော ဝန်ခံချက်ကို ၎င်းအား ဖတ်ပြရာ ဖြောင့်ချက်/ဝန်ခံချက်သည် ဟုတ်မှန် ကြောင်းနှင့် ၎င်း၏ ဆန္ဒအတိုင်းအလိုအလျောက် ပေးထားကြောင်းဝန်ခံသည်။ ဖြောင့်ချက်/ဝန်ခံချက်ပါ အချက် အလက်များကို တရားရုံးရှေ့တွင် အလုံးစုံ မခြွင်းမချန်အမှန်အတိုင်း ထွက်ဆိုပါမည်ဟူသော စည်းကမ်းချက် ဖြင့် တရားခံအား ပြစ်ဒဏ်မှ လွတ်ငြိမ်းခွင့်ပေးသင့်သည်ဟု ယူဆသည်။</span>
                </div>
              </div>
    
              {/* Paragraph 3 */}
              <div className="relative pl-8 pt-4">
                <span className="absolute left-0 top-4 font-bold">၃။</span>
                <div className="inline">
                  <span>သို့ဖြစ်ပါ၍ ဦး</span>
                  
                  {isPreview ? (
                    <span className="border-b border-black font-semibold px-4 mx-1 min-w-[10rem] inline-block text-center">{formData.fatherName || '.......'}</span>
                  ) : (
                    <input 
                      type="text" 
                      name="fatherName"
                      value={formData.fatherName}
                      onChange={handleChange}
                      className="w-44 text-center bg-transparent border-b border-dotted border-black focus:outline-none mx-1"
                    />
                  )}
    
                  <span>၏ သား/သမီးဖြစ်သူ တရားခံ</span>
                  
                  {isPreview ? (
                    <span className="border-b border-black font-semibold px-4 mx-1 min-w-[6rem] inline-block text-center">{formData.accusedName || '.......'}</span>
                  ) : (
                    <input 
                      type="text" 
                      name="accusedName"
                      value={formData.accusedName}
                      onChange={handleChange}
                      placeholder=""
                      className="w-20 text-center bg-transparent border-b border-dotted border-black focus:outline-none"
                    />
                  )}
    
                  <span>အား ရာဇဝတ်ကျင့်ထုံးဥပဒေပုဒ်မ ၃၃၇ အရ အစိုးရသက်သေပြုလုပ်ရန် စည်းကမ်းချက်ဖြင့် ပြစ်ဒဏ်မှ လွတ်ငြိမ်းခွင့် ပေးလိုက်သည်။</span>
                </div>
              </div>
    
            </div>
    
            {/* Signature Box Block */}
            <div className="mt-16 flex flex-col items-end justify-end text-sm md:text-base print:mt-12">
              <div className="w-80 flex flex-col space-y-2">
                
                {/* Signature Box Canvas Trigger */}
                <div className="flex items-center">
                    <span className="w-24 text-right text-sm whitespace-nowrap mr-2">လက်မှတ်</span>
                    <div
                      onClick={() => isEditable && setIsSigning(true)}
                      className={`flex-1 bg-transparent border-b border-dotted border-black min-h-[32px] flex items-center justify-center relative group ${
                        isEditable ? "cursor-pointer hover:bg-gray-50 transition" : ""
                      }`}
                    >
                      {formData.signatureImage ? (
                        <>
                          <img
                            src={formData.signatureImage}
                            alt="Signature"
                            className="h-8 object-contain mix-blend-multiply"
                          />
                          {isEditable && (
                            <span className="absolute inset-0 bg-black/40 text-white text-xs opacity-0 group-hover:opacity-100 flex items-center justify-center transition rounded print:hidden">
                              လက်မှတ်အသစ်ထိုးရန် နှိပ်ပါ
                            </span>
                          )}
                        </>
                      ) : (
                        isEditable && (
                          <span className="text-gray-400 text-xs font-sans print:hidden">
                            ✍️ ဒီနေရာတွင် လက်မှတ်ထိုးရန် နှိပ်ပါ
                          </span>
                        )
                      )}
                      {/* {formData.signatureImage && (
                        <button
                          type="button"
                          onClick={handleClearSignature}
                          title="လက်မှတ်ရှင်းလင်းမည်"
                          className="absolute -right-6 text-slate-400 hover:text-rose-500 text-xs px-1 font-bold z-10 print:hidden"
                        >
                          ✕
                        </button>
                      )} */}
                    </div>              
                  </div>
    
                {/* Name Form Box */}
                <div className="flex items-center">
                  <span className="w-16 text-right whitespace-nowrap mr-2">အမည်</span>
                  {isPreview ? (
                    <span className="flex-1 text-center font-semibold border-b border-black min-h-[24px]">{formData.signName}</span>
                  ) : (
                    <input
                      type="text"
                      name="signName"
                      value={formData.signName}
                      onChange={handleChange}
                      className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none text-center"
                    />
                  )}
                </div>
    
                {/* Role Title */}
                <div className="text-center font-bold text-sm pt-1 pl-12">
                  တာဝန်ခံဥပဒေအရာရှိ
                </div>
    
                {/* Law Office Control */}
                <div className="flex items-end justify-end">
                  <div className="flex justify-center items-center gap-2">
                    <DatalistInput
                      name="lawOffice"
                      value={formData.lawOffice || ""}
                      onChange={handleChange}
                      placeholder=""
                      options={OFFICE_OPTIONS}
                      disabled={!isEditable}
                    />
                    <span className="w-24 text-left">ဥပဒေရုံး</span>
                  </div>
                </div>
    
              </div>
            </div>
    
            {/* Bottom Page Number Indicators */}
            <div className="absolute bottom-6 left-8 text-xs text-gray-400 print:bottom-0 print:left-0">၁၂၀</div>
    
            {/* Action Buttons */}
            {/* Form Action Buttons Component Integration */}
              {/* <FormActionButtons
                isPreview={isPreview}
                isEditable={isEditable}
                isSubmitting={isSubmitting}
                isFormSigned={isFormSigned}
                isApproved={isApproved}
                targetGeoLevels={formData.targetGeoLevels}
                currentGeoLevel={currentUser?.scopeLevel}
                selectedGeoLevels={selectedGeoLevels}
                onGeoLevelChange={setSelectedGeoLevels}
                onCancel={handleBackNavigation}
                onSaveDraft={handleSaveDraft}
                onApproveAndSave={handleApproveAndSave}
                onSubmitToSuperior={handleSubmitToSuperior}
              />
     */}
            {/* Signature Modal */}
            {/* <SignatureModal
              isOpen={isSigning}
              sigCanvasRef={sigCanvasRef}
              onClose={() => setIsSigning(false)}
              onClear={() => sigCanvasRef.current?.clear()}
              onSave={handleSaveSignature}
            /> */}
    
            <div className="absolute bottom-4 left-4 text-xs text-gray-400 print:bottom-0 print:left-0">
              လျှို့ဝှက်
            </div>
          
          </div>
  );
};